import React from 'react';
import PropTypes from 'prop-types';

const SubTitle = ({ className, children }) => (
  <h3
    className={`mb-5 sm:mb-7 text-primary-dark font-medium text-xl md:text-2xl tracking-wider ${
      className || ''
    }`}
  >
    {children}
  </h3>
);

SubTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
};

export default SubTitle;
